interface SliderProps {
  image: string;
  title: string;
  padding?: number;
}

export const sliderData: Record<string, SliderProps> = {
  pro: {
    image: '/assets/devices/types/go-e_Charger_Pro.png',
    title: 'go-e Charger PRO',
  },
  core: {
    image: '/assets/devices/types/go-e_Charger_Core.png',
    title: 'go-e Charger CORE',
  },
  v4: {
    image: '/assets/devices/types/go-e_Charger_V4_Fix.png',
    title: 'go-e Charger Gemini Flex',
  },
  v3: {
    image: '/assets/devices/types/go-eCharger.png',
    title: 'go-e Charger HOMEfix/HOME+',
  },
  controller: {
    image: '/assets/devices/types/go-e_Controller.png',
    title: 'go-e Controller',
  },
  controller_ultralight: {
    image: '/assets/devices/types/go-e_Controller_Ultralight.png',
    title: 'go-e Controller Ultralight',
  },
};
